import { styled } from '@mui/material';

/** 레거시 .list-bagic-line — 라벨 옆에 값을 왼쪽 정렬 */
export const InfoListRoot = styled('ul')`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #1a1a1a);

  & > li {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
  }
  & > li:first-of-type {
    border-top: 1px solid var(--dk-line, #e7e9ec);
  }
  & > li > .tit {
    flex-shrink: 0;
    padding-right: 10px;
    font-weight: 500;
    word-break: keep-all;
  }
  & > li > .cont {
    min-width: 0;
    word-break: break-all;
  }
`;
